module.exports = __webpack_public_path__ + "img/contratei.d3c3d060.png";